import type { StyleSpecification } from "maplibre-gl";
import {
  GLYPHS,
  HILLSHADE_TILEJSON,
  RASTER_TILEJSON,
  SOURDOUGH_TILEJSON,
  VECTOR_TILEJSON,
} from "../config.ts";
import { BASEMAP_ABOVE, BASEMAP_BELOW, HILLSHADE_SOURCE, SOURDOUGH } from "./basemap.ts";
import { DENSITY, DENSITY_SOURCE, WETLAND_SOURCE, WETLANDS } from "./wetlands.ts";

const ATTRIBUTION =
  '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>';

export function buildStyle(): StyleSpecification {
  return {
    version: 8,
    glyphs: GLYPHS,
    sources: {
      [SOURDOUGH]: {
        type: "vector",
        url: SOURDOUGH_TILEJSON,
        attribution: ATTRIBUTION,
      },
      [WETLAND_SOURCE]: {
        type: "vector",
        url: VECTOR_TILEJSON,
      },
      [DENSITY_SOURCE]: {
        type: "raster",
        url: RASTER_TILEJSON,
      },
      [HILLSHADE_SOURCE]: {
        type: "raster",
        url: HILLSHADE_TILEJSON,
      },
    },
    layers: [...BASEMAP_BELOW, ...DENSITY, ...WETLANDS, ...BASEMAP_ABOVE],
  };
}
